import { User, UserType } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';
import { SWRConfig } from 'swr';

import { UserCredentialsType } from '@/components/modules/Users/types/UserCredentials';
import { BlockUserMessage } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/BlockUserMessage';
import { ChangePassword } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangePassword/ChangePassword';
import { ChangeToAnotherChannel } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangeToAnotherChannel/ChangeToAnotherChannel';
import { ChangeUser } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangeUser/ChangeUser';
import { ChangeUserById } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangeUserById/ChangeUserById';
import { PasswordRecoveryList } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/PasswordRecoveryList/PasswordRecoveryList';
import { RemoveOrAddTwoFactorAuth } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/RemoveOrAddTwoFactorAuth';
import { SendForgotPasswordEmail } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/SendForgotPasswordEmail';
import { UnblockUserMessage } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/UnblockUserMessage';
import { UserRowActionType } from '@/components/shared/components/UserList/types/UserRowActionType';

interface UserActionsRowDialogProps {
  userId: string;
  selectedUser: User;
  userAction: UserRowActionType;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
}

export const UserActionsRowDialog = ({
  userId,
  selectedUser,
  userAction,
  opened,
  setOpened,
  toggleDialog,
}: UserActionsRowDialogProps) => {
  if (!userAction || !opened) return <></>;

  return (
    <>
      <SWRConfig value={{ revalidateOnMount: false }}>
        {userAction === UserRowActionType.BLOCK_USER && (
          <BlockUserMessage
            selectedUser={selectedUser}
            userId={userId}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {userAction === UserRowActionType.UNBLOCK_USER && (
          <UnblockUserMessage
            userId={userId}
            selectedUser={selectedUser}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {userAction === UserRowActionType.CHANGE_PASSWORD && (
          <ChangePassword
            selectedUser={selectedUser}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {userAction === UserRowActionType.SEND_FORGOT_PASSWORD_EMAIL && (
          <SendForgotPasswordEmail
            selectedUser={selectedUser}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {userAction === UserRowActionType.SEE_PASSWORD_RECOVERY_LIST && (
          <PasswordRecoveryList id={selectedUser.id} opened={opened} setOpened={setOpened} handleClose={toggleDialog} />
        )}
        {userAction === UserRowActionType.CHANGE_USER && (
          <ChangeUser
            userId={userId}
            selectedUser={selectedUser}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {userAction === UserRowActionType.CHANGE_USER_BY_ID && (
          <ChangeUserById
            userId={userId}
            selectedUser={selectedUser}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {(userAction === UserRowActionType.ADD_TWO_FACTOR_AUTH ||
          userAction === UserRowActionType.REMOVE_TWO_FACTOR_AUTH) && (
          <RemoveOrAddTwoFactorAuth
            userId={userId}
            actionType={userAction}
            selectedUser={selectedUser}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {userAction === UserRowActionType.CHANGE_TO_ANOTHER_CHANNEL && (
          <ChangeToAnotherChannel
            userCredentialsType={
              selectedUser.userType === UserType.AGENT ? UserCredentialsType.AGENT : UserCredentialsType.ADMIN
            }
            opened={opened}
            setOpened={setOpened}
            toggleDialog={toggleDialog}
            selectedUser={selectedUser}
          />
        )}
      </SWRConfig>
    </>
  );
};
